import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import Loading from '../loading/Loading';
import { labelGrid } from '../utils';

function CustomTableSelectUsuarios(props: {
    data: any[], buscouUsuarios: boolean, handleSetUsuario: (usuario: any) => void,
    handleEditarUsuario: (usuario: any) => void,
    handleVisualizarUsuario?: (usuario: any) => void,
    editavel: boolean
}) {
    const rows = props.data;
    const showCollsTable = ['codAgente', 'nome', 'email', 'nomeEmpresa', 'ativo'];
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#e9f2fd',
            color: '#0f3550',
            fontSize: '12px',
            letterSpacing: '0.6px',
            padding: '4px 16px',
            marginTop: '-5px',
            borderBottom: '2px solid #d9e5ee',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            whiteSpace: 'nowrap',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: '12px',
            color: '#334155',
            padding: '5px 16px',
            borderBottom: '1px solid #E2E8F0',
        },
    }));

    const StyledTableRow = styled(TableRow)(() => ({
        height: '32px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#f8fafc',
        },
        '&:hover': {
            backgroundColor: '#eef4fb',
            transition: 'background-color 0.15s ease',
        },
        '&:last-child td, &:last-child th': {
            borderBottom: 0,
        },
    }));


    return (
        <TableContainer
            component={Paper}
            sx={{
                height: '100%',
                maxHeight: '100%',
                overflowY: 'auto',
                overflowX: 'auto',
                boxShadow: 'none',
                borderRadius: '4px',
                border: '1px solid #e2e8f0',
            }}
        >
            <Table aria-label="customized table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell sx={{ width: 80, whiteSpace: "nowrap", textAlign: "left !important" }}>{labelGrid.codAgente}</StyledTableCell>
                        <StyledTableCell sx={{ width: 250, textAlign: "left !important" }}>{labelGrid.nome}</StyledTableCell>
                        <StyledTableCell sx={{ width: 250, textAlign: "left !important" }}>{labelGrid.email}</StyledTableCell>
                        <StyledTableCell sx={{ width: 190, textAlign: "left !important" }}>{labelGrid.nomeEmpresa}</StyledTableCell>
                        <StyledTableCell sx={{ width: 80, textAlign: "left !important" }}>{labelGrid.ativo}</StyledTableCell>
                        <StyledTableCell sx={{ width: 96, textAlign: "center !important" }}>{labelGrid.opcoes}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows && rows.length > 0 ? (
                        rows.map((row: any, index: number) => (
                            <StyledTableRow key={index}>
                                {showCollsTable.map((col) => (
                                    <TableCell key={col} align="left" sx={{ fontSize: '12px', color: '#334155', padding: '5px 16px', borderBottom: '1px solid #E2E8F0' }}>
                                        {col === "ativo"
                                            ? (row[col] === 'S' ? "ATIVO" : "INATIVO")
                                            : (row[col] !== null && row[col] !== undefined && row[col] !== ''
                                                ? row[col]
                                                : <span style={{ color: '#94a3b8', fontSize: '12px' }}>N/D</span>)}
                                    </TableCell>
                                ))}
                                <TableCell align="center" sx={{ width: 96, padding: '2px 8px', borderBottom: '1px solid #E2E8F0' }}>
                                    {!props.editavel &&
                                        <Tooltip title="Adicionar">
                                            <IconButton
                                                onClick={() => props.handleSetUsuario(row)}
                                                size="small"
                                                sx={{ color: '#0965c1', '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' } }}
                                            >
                                                <AddCircleIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    {props.editavel && (
                                        <Tooltip title="Editar">
                                            <IconButton
                                                size="small"
                                                onClick={() => props.handleEditarUsuario(row)}
                                                sx={{ color: '#0965c1', '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' } }}
                                            >
                                                <EditIcon sx={{ fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {props.editavel && (
                                        <Tooltip title="Visualizar">
                                            <IconButton
                                                size="small"
                                                onClick={() => props.handleVisualizarUsuario?.(row)}
                                                sx={{ color: '#0965c1', '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' } }}
                                            >
                                                <VisibilityIcon sx={{ fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={showCollsTable.length + 1} align="center" sx={{ py: 6, borderBottom: 0 }}>
                                <span style={{ color: '#94a3b8', fontSize: '14px' }}>Nenhum usuário encontrado</span>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default CustomTableSelectUsuarios;